import type { ReactElement } from 'react';
import type { CustomIconProps } from '../types';

export const NavigationSlideArrowRightIcon = ({ width, height }: CustomIconProps): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '32'}
        height={height || '32'}
        viewBox="0 0 32 32"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 30.6667C24.1002 30.6667 30.6667 24.1002 30.6667 16C30.6667 7.89982 24.1002 1.33333 16 1.33333C7.89982 1.33333 1.33333 7.89982 1.33333 16C1.33333 24.1002 7.89982 30.6667 16 30.6667ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            fill="#C6C6C6"
        />
        <path
            d="M16.0026 30.6666C24.1028 30.6666 30.6693 24.1001 30.6693 15.9999C30.6693 7.89974 24.1028 1.33325 16.0026 1.33325C7.90243 1.33325 1.33594 7.89974 1.33594 15.9999C1.33594 24.1001 7.90243 30.6666 16.0026 30.6666Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1779 8.18024C13.4151 7.93992 13.7997 7.93992 14.0368 8.18024L20.4663 14.6946C21.1779 15.4155 21.1779 16.5845 20.4663 17.3054L14.0368 23.8198C13.7997 24.0601 13.4151 24.0601 13.1779 23.8198C12.9407 23.5794 12.9407 23.1898 13.1779 22.9495L19.6074 16.4351C19.8446 16.1948 19.8446 15.8052 19.6074 15.5649L13.1779 9.05053C12.9407 8.8102 12.9407 8.42056 13.1779 8.18024Z"
            fill="#414042"
        />
    </svg>
);
